export interface RadioStation {
  id: string;
  name: string;
  shortName?: string;
  subtitle: string;
  streamUrl: string | undefined;
  fallbackAudio: string;
  color: string;
  bg: string;
  border: string;
  theme: 'orange' | 'blue' | 'green';
  isEnabled: boolean;
  priority: number;
}

export const RADIO_STATIONS: RadioStation[] = [
  {
    id: 'rci',
    name: 'RCI',
    subtitle: 'Votre radio favorite',
    streamUrl: process.env.NEXT_PUBLIC_RCI_STREAM_URL,
    fallbackAudio: '/audio/rci-demo.mp3',
    color: '#F5A623',
    bg: '#FFF8EC',
    border: 'rgba(245,166,35,0.35)',
    theme: 'orange',
    isEnabled: true,
    priority: 1,
  },
  {
    id: 'martinique-1ere',
    name: 'Martinique La 1ère',
    shortName: 'Martinique 1ère',
    subtitle: 'Radio Martinique',
    streamUrl: process.env.NEXT_PUBLIC_MARTINIQUE_1ERE_STREAM_URL,
    fallbackAudio: '/audio/martinique-1ere-demo.mp3',
    color: '#3B82F6',
    bg: '#EFF6FF',
    border: 'rgba(59,130,246,0.3)',
    theme: 'blue',
    isEnabled: true,
    priority: 2,
  },
  {
    id: 'france-inter',
    name: 'France Inter',
    subtitle: 'Radio nationale',
    streamUrl: process.env.NEXT_PUBLIC_FRANCE_INTER_STREAM_URL,
    fallbackAudio: '/audio/france-inter-demo.mp3',
    color: '#5DBB1F',
    bg: '#F0FBE8',
    border: 'rgba(93,187,31,0.3)',
    theme: 'green',
    isEnabled: true,
    priority: 3,
  },
];

/**
 * Préférences radio du profil senior.
 * Prépare la structure pour une future configuration depuis l'application Famille.
 * V1 : valeurs de démonstration stockées ici.
 */
export const SENIOR_RADIO_PREFERENCES = {
  favoriteStationId: 'rci',
  priorityStationIds: ['rci', 'martinique-1ere', 'france-inter'] as string[],
  defaultVolume: 70,
};

/**
 * Retourne les stations prioritaires actives, triées par priorité.
 * Maximum 3 stations affichées dans la vignette Accueil essentiel.
 */
export function getPriorityStations(maxCount = 3): RadioStation[] {
  const { priorityStationIds } = SENIOR_RADIO_PREFERENCES;
  return priorityStationIds
    .map(id => RADIO_STATIONS.find(s => s.id === id))
    .filter((s): s is RadioStation => s !== undefined && s.isEnabled)
    .slice(0, maxCount);
}

export function getStation(id: string): RadioStation | undefined {
  return RADIO_STATIONS.find(s => s.id === id);
}
